import React, { useState } from 'react';
import './App.css';
import UploadForm from './components/UploadForm';
import DocumentList from './components/DocumentList';
import VerificationPanel from './components/VerificationPanel';

type UserRole = 'uploader' | 'verifier' | 'admin';

export default function App() {
  const [userRole, setUserRole] = useState<UserRole>('uploader');
  const [userId] = useState('user-' + Math.random().toString(36).substr(2, 9));
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const handleUploadSuccess = () => {
    setRefreshTrigger(prev => prev + 1);
  };

  return (
    <div className="app">
      <header className="app-header">
        <h1>📄 Sistema de Verificação de Documentos</h1>
        <div className="role-selector">
          <label>Seu papel: </label>
          <select value={userRole} onChange={(e) => setUserRole(e.target.value as UserRole)}>
            <option value="uploader">📤 Enviador de Documentos</option>
            <option value="verifier">✅ Verificador</option>
            <option value="admin">⚙️ Administrador</option>
          </select>
        </div>
      </header>

      <main className="app-main">
        {userRole === 'uploader' && (
          <>
            <section className="section">
              <h2>Enviar Novo Documento</h2>
              <UploadForm userId={userId} onSuccess={handleUploadSuccess} />
            </section>
            <section className="section">
              <h2>Meus Documentos</h2>
              <DocumentList userId={userId} refreshTrigger={refreshTrigger} />
            </section>
          </>
        )}

        {userRole === 'verifier' && (
          <>
            <section className="section">
              <h2>Documentos para Verificar</h2>
              <VerificationPanel refreshTrigger={refreshTrigger} />
            </section>
            <section className="section">
              <h2>Histórico de Verificações</h2>
              <DocumentList status="verified" refreshTrigger={refreshTrigger} />
            </section>
          </>
        )}

        {userRole === 'admin' && (
          <>
            <section className="section">
              <h2>Todos os Documentos</h2>
              <DocumentList refreshTrigger={refreshTrigger} />
            </section>
          </>
        )}
      </main>

      <footer className="app-footer">
        <p>© 2024 Sistema de Verificação de Documentos. Desenvolvido com Cloudflare Workers.</p>
      </footer>
    </div>
  );
}
